import { createFeatureSelector, createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';
import { FreeplayState } from "../../NGRX/freeplay/freeplay.model";

// Feature selector
export const freeplayState: MemoizedSelector<object, FreeplayState, DefaultProjectorFn<FreeplayState>> =
  createFeatureSelector<FreeplayState>('freeplay');

// List related selectors
export const selectFreeplayList = createSelector(
  freeplayState,
  (state: FreeplayState) => state.list
);

export const selectFreeplayListError = createSelector(
  freeplayState,
  (state: FreeplayState) => state.list_error
);

export const freeplayListLoading = createSelector(
  freeplayState,
  (state: FreeplayState) => state.is_loading
);

// Token related selectors
export const selectFreeplayToken = createSelector(
  freeplayState,
  (state: FreeplayState) => state.token
);

export const selectFreeplayTokenError = createSelector(
  freeplayState,
  (state: FreeplayState) => state.token_error
);
